import { render, staticRenderFns } from "./inviteApply.vue?vue&type=template&id=45cc666b&scoped=true"
import script from "./inviteApply.vue?vue&type=script&lang=js"
export * from "./inviteApply.vue?vue&type=script&lang=js"
import style0 from "./inviteApply.vue?vue&type=style&index=0&id=45cc666b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cc666b",
  null
  
)

export default component.exports